/**
 * degradedAnalysisVocabulary — the one short-label vocabulary for `AnalysisOutput.degraded`
 * across the operator surfaces (FULL-0018).
 *
 * `degraded` is set only when content is NOT a real model answer: the deterministic mock
 * (`mock`) that the pilot default builds when no `ANALYSIS_PROVIDER` is configured, or an
 * unparseable model reply's safe fallback (`parse_failed`). The producer's own contract is that
 * whoever shows such content says so, because presenting it as the employee's own work is a claim
 * the product cannot support.
 *
 * These are the SHORT forms, for rows that cannot carry the full sentence banner
 * `AgentRunDetailPage` draws. They are the same two arms worded the same way, so no surface can
 * describe one run two ways. `ApprovalDecisionBrief` and `HandoffBriefing` draw their own longer
 * banner wording for the same arms; those are sentences, not labels.
 */
export const DEGRADED_ANALYSIS_LABELS = {
  mock: "ניתוח דמה — ספק AI לא מוגדר, אינו אבחון אמיתי",
  parse_failed: "המודל לא החזיר תשובה קריאה — ניתוח גיבוי, אינו אבחון אמיתי",
};

// An arm this build does not recognise is still declared degraded by the producer, so it is
// labelled generically rather than echoed raw — the value is a disclosure, not a data channel.
export const DEGRADED_ANALYSIS_UNKNOWN_LABEL = "ניתוח גיבוי — אינו אבחון אמיתי";

// An aggregate surface reports how many of the analyses behind a figure are fallback content, not
// which arm each one took, so it needs a plural form of the same fact. It lives here rather than at
// the call site to keep one home for the wording; it does not replace the per-arm labels above,
// which a surface that names a single analysis still draws.
export const DEGRADED_ANALYSES_AGGREGATE_LABEL = "ניתוחי גיבוי — אינם אבחון אמיתי";

/** The disclosure label for a `degraded` value, or null when the content is not degraded. */
export function degradedAnalysisLabel(value) {
  if (!value) return null;
  return DEGRADED_ANALYSIS_LABELS[value] || DEGRADED_ANALYSIS_UNKNOWN_LABEL;
}
